import domToImage from "dom-to-image"

export const isTouchEvent = (e: MouseEvent | TouchEvent): e is TouchEvent => {
  return "touches" in e
}

export const replaceCanvasWithSvg = async (html: HTMLElement) => {
  const updatedHtml = html.cloneNode(true) as HTMLElement

  // make sure cloned element keeps the same size without having parent styles affecting it (grid, flex etc.)
  updatedHtml.style.width = `${html.clientWidth}px`
  updatedHtml.style.height = `${html.clientHeight}px`

  const originalCanvases = Array.from(html.querySelectorAll("canvas"))
  const clonedCanvases = Array.from(updatedHtml.querySelectorAll("canvas"))

  const svgContents = await Promise.all(originalCanvases.map((canvas) => domToImage.toSvg(canvas)))

  for (const [index, mockedCanvas] of clonedCanvases.entries()) {
    const svgContent = svgContents[index]

    if (!svgContent) continue

    const svgData = svgContent.split("data:image/svg+xml;charset=utf-8,")[1]

    if (!svgData) continue

    const svgElement = new DOMParser().parseFromString(svgData, "image/svg+xml").documentElement

    mockedCanvas.parentNode?.replaceChild(svgElement, mockedCanvas)
  }

  return updatedHtml
}

export const waitForNextPaint = () =>
  new Promise<void>((resolve) => requestAnimationFrame(() => resolve()))
